import en from './en.json';
import nl from './nl.json';

export default{
    en,
    nl
};
